import * as i from 'types';
import * as React from 'react';
import 'styled-components';

import EFLogoPng from 'images/ef-logo.png';

export const defaultTheme = {
  colors: {
    primary: '#0099FF',
    primaryDeep: '#000099',
    secondary: '#F6662B',
    black: '#1A1A1A',
    white: Object.assign('#FFFFFF', {
      off: '#F7F7F7',
      border: '#FFFFFF20',
      dark: '#ECEEF0',
    }),
    blue: Object.assign('#0099FF', {
      'deep': '#000099',
      'light': '#E6F5FF',
      '100': '#EAF1F8', // NN color
      '700': '#4881BE', // NN color
    }),
    gray: Object.assign('#404040', {
      'neutral': '#8C8A8D',
      'border': '#CFCECF',
      'soft': '#ededed',
      'disabled': '#F9F9F9',
      'background': '#F7F7F7',
      'dark': '#606060',
      'tableBorder': '#00000029',
      '800': '#6D6D6D', // NN color
      '1000': '#404040', // NN color
      '1200': '#1A1A1A', // NN color
    }),
    // The default orange below is the official NN orange color ('Medium Orange')
    orange: Object.assign('#EA650D', {
      '300': '#FAC39F', // NN color
      '800': '#B54E0A', // NN color
    }),
    darkOrange: '#EB5315',
    red: '#EB3456',
    sand: {
      '100': '#F3EFED', // NN color
      '200': '#E6DFDA', // NN color
    },
  },

  ui: {
    borderRadius: {
      card: '32px',
      badge: '12px',
      button: '16px',
      buttonSmall: '8px',
      buttonToggle: '6px',
      circle: '100%',
    },
    shadows: Object.assign(
      '0px 0px 1px 0px rgba(0, 0, 0, 0.40), 0px 6px 6px -6px rgba(0, 0, 0, 0.16);',
      {
        primary:
          '0px 8px 24px -6px rgba(0, 153, 255, 0.2), 0px 0px 1px rgba(0, 0, 0, 0.4)',
      },
    ),
  },

  fonts: {
    noto: '"Noto Sans", sans-serif',
    nnNittiGrotesk: '"NN Nitti Grotesk", sans-serif',
  },
  logo: EFLogoPng,
  sizes: {
    headerHeight: {
      mobile: '64px',
      desktop: '96px',
    },
  },
};

export const useTheme = (partner: i.Partner) => {
  const [theme, setTheme] = React.useState<i.Theme>(defaultTheme);

  React.useEffect(() => {
    if (partner) {
      setTheme({
        ...defaultTheme,
        colors: {
          ...defaultTheme.colors,
          primary: partner.primaryColor,
          primaryDeep: partner.primaryDeep,
          secondary: partner.secondaryColor,
        },
        logo: partner.logo.file.url,
      });
    }
  }, []);

  return {
    theme,
    partner,
  };
};
